<template>
    <custom-tooltip v-model="isOpen" border>
        <app-button circle icon :loading="loading" @click="onClick">
            {{ icon }}
        </app-button>
        <template #tooltip> {{ message }} </template>
    </custom-tooltip>
</template>

<script>
export default {
    props: {
        message: { default: "Nuevo", type: String, required: true },
        icon: { default: "🔁", type: String, required: false },
        loading: { default: false, type: Boolean, required: false }
    },
    emits: ["click"],
    data: () => ({ isOpen: false, enabledRedirect: false }),
    methods: {
        onClick() {
            if (this.isOpen) {
                this.isOpen = false;
            } else {
                this.isOpen = true;
                setTimeout(() => (this.isOpen = false), 2000);
            }
            this.$emit("click");
        }
    }
};
</script>
